import { INews, INewsResponse } from "src/app/models/news.model";

export class NewsState {
  allNews: INewsResponse;
  detailNews: INews;
  rssNews: any;
  getLoading: boolean;
  isError: boolean;
  searchText: string;

  constructor() {}
}
